import { useSelector } from "react-redux";

import { selectCurrentUser } from "../../store/reducers/user";
import { Invoice } from "../../types/InvoiceTypes";

export const useValidateInvoiceAmountWithFirstKYCLevel = (
  invoice?: Invoice
) => {
  const { kyc_complete_and_approved, kyc_first_level_amount_threshold } =
    useSelector(selectCurrentUser);

  const amount = invoice?.transaction_details
    ? invoice?.transaction_details.amount
    : invoice?.amount || 0;

  const value = (amount / kyc_first_level_amount_threshold) * 100;
  const valid = kyc_complete_and_approved || value <= 100;

  return {
    threshold: kyc_first_level_amount_threshold,
    amount,
    value,
    valid,
  };
};
